// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const IS_SOLD_POLL_BUTTON_NO = "Ne";
export const IS_SOLD_POLL_BUTTON_YES = "Ano, v\u011bc jsem prodala p\u0159es Kon\u00edka";
export const IS_SOLD_POLL_NOTE = "jestli jsi inzer\u00e1t prodala p\u0159es jinou str\u00e1nku, darovala, vyhodila, (...), stla\u010d Ne";
export const IS_SOLD_POLL_TITLE = "Prodala jsi tuto v\u011bc p\u0159es Kon\u00edka?";
